export const OUR_OFFERINGS = "Our Key PMS Offerings";
export const OUR_OFFERINGS_NOTE =
  "Kindly refer to the Disclosure Document for details of other strategies and including risk factors.";
